import {NgModel} from './ngModel';

export const Language = NgModel.extend({
    _name: 'Language',
});
